// extracted by mini-css-extract-plugin
export var PersonCTA = "PersonCTA-module--PersonCTA--52d1c";
export var description = "PersonCTA-module--description--d0051";
export var email = "PersonCTA-module--email--92a1a";
export var phone = "PersonCTA-module--phone--1f4ab";
export var textContent = "PersonCTA-module--textContent--5aa91";